var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-transfer',{attrs:{"value":_vm.value,"data":_vm.data,"titles":_vm.titles},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }